<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('schedule.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('schedule.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'schedule-create' })"
              >{{ $t('add_new') }}</ts-button
            >
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('Search')"
              style="width: 300px"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('invoice.filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
          field: 'academic_program_sub.acps_name_foreign'
        }"
      >
        <template v-slot="{ record }">
          <td>
            {{
              record.academic_class != null
                ? record.academic_class.branch != null
                  ? record.academic_class.branch.branch_name_en
                  : ''
                : ''
            }}
          </td>
          <td>
            {{
              record.academic_class != null
                ? record.academic_class.class_name
                : ''
            }}
          </td>
          <td>
            {{
              record.weekday_from != null ? record.weekday_from.wd_name_en : ''
            }}
          </td>
          <td>
            {{ record.weekday_to != null ? record.weekday_to.wd_name_en : '' }}
          </td>
          <td>
            {{
              record.schedule_type != null
                ? record.schedule_type.sch_type_name
                : ''
            }}
          </td>
          <td>
            {{
              record.academic_year != null ? record.academic_year.ac_year : ''
            }}
          </td>
          <td class="text-center">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="mr-2 text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a
              href="#"
              class="text-info ts-mr-2"
              @click.prevent="copySchedule(record)"
              v-tooltip="$t('copy')"
            >
              <i class="fas fa-copy"></i>
            </a>
            <a
              href="#"
              v-tooltip="$t('schedule.classSchedule')"
              class="text-primary"
              @click.prevent="schedule(record)"
            >
              <i class="fas fa-calendar-alt"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- drawer -->
      <a-drawer
        :title="$t('invoice.filter')"
        placement="right"
        :closable="false"
        :visible="visible"
        @close="() => (visible = false)"
        :zIndex="1020"
        width="300px"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <a-select
                style="width: 257px"
                v-model="branch_id"
                :options="branchs"
                showSearch
                mode="multiple"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                :maxTagCount="1"
                :maxTagTextLength="17"
                :placeholder="$t('all')"
                @change="onChangeBranch"
              >
              </a-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="ts-text-xs">{{
                $t('schedule.academicYear')
              }}</label>
              <a-select
                style="width:100%"
                v-model="ac_year_id"
                :options="acYearOptions"
                :show-search="true"
                :maxTagCount="1"
                mode="multiple"
                :placeholder="$t('all')"
                :filter-option="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                @change="onChangeAcYear"
              ></a-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="ts-text-xs">{{ $t('schedule.term') }}</label>
              <a-select
                style="width:100%"
                v-model="ac_term_id"
                :options="termOptions"
                :show-search="true"
                :maxTagCount="1"
                mode="multiple"
                :placeholder="$t('all')"
                :filter-option="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                @change="onChangeTerms"
              ></a-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="ts-text-xs">{{ $t('schedule.class') }}</label>
              <a-select
                style="width:100%"
                v-model="class_id"
                :options="acClassOptions"
                :show-search="true"
                :maxTagCount="1"
                mode="multiple"
                :placeholder="$t('all')"
                :filter-option="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
              ></a-select>
            </div>
          </div>
        </div>
      </a-drawer>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'schedule-table',
  data() {
    return {
      branchs: [],
      acYearOptions: [],
      branch_id: [],
      ac_year_id: [],
      class_id: [],
      ac_term_id: [],
      termOptions: [],
      acClassOptions: [],
      loading: false,
      visible: false
    }
  },
  mounted() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.getBranch()
    this.getTerms()
  },
  computed: {
    ...mapState('schedule', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.schedule.search
      },
      set(newValue) {
        this.$store.commit('schedule/SET_SEARCH', newValue)
        this.$store.commit('schedule/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('schedule.branch'),
          sortKey: 'academic_class.branch.branch_name_en',
          style: 'width: 10%'
        },
        {
          name: this.$t('schedule.className'),
          sortKey: 'academic_class.class_name'
        },
        {
          name: this.$t('schedule.dayFrom'),
          sortKey: 'academic_class.class_name'
        },
        { name: this.$t('schedule.dayTo'), sortKey: 'weekday_from.wd_name_en' },
        { name: this.$t('schedule.type'), sortKey: 'weekday_to.wd_name_en' },
        { name: this.$t('schedule.academicYear') },
        { name: this.$t('actions'), style: 'width: 1%; text-align: center' }
      ]
    }
  },
  methods: {
    ...mapActions('schedule', ['fetchClass', 'fetchTerms']),
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'schedule/fetch',
          Object.assign(
            {},
            {
              branch_id: this.branch_id,
              ac_year_id: this.ac_year_id,
              ac_term_id: this.ac_term_id,
              class_id: this.class_id
            },
            attributes
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
        .finally(() => {
          if (this.branch_id) {
            this.$store
              .dispatch(
                'schedule/getAcademicYear',
                Object.assign({ branch_id: this.branch_id })
              )
              .then(response => {
                this.acYearOptions = response.data.map(el => ({
                  ac_status_id: el.ac_status_id,
                  value: el.ac_year_id,
                  label:
                    el.ac_year +
                    (el.ac_status_id == 1
                      ? ' ( Current ) '
                      : el.ac_status_id == 2
                      ? ' ( History ) '
                      : ' ( Next ) ') +
                    el.branch.branch_name_en
                }))

                // set on active academic year
                this.ac_year_id = this.acYearOptions
                  .filter(ac => ac.ac_status_id === 1)
                  .map(el => el.value)
                return response
              })
          }
        })
    },
    onChangeBranch() {
      this.acYearOptions = []
      this.$store
        .dispatch(
          'schedule/getAcademicYear',
          Object.assign({ branch_id: this.branch_id })
        )
        .then(response => {
          this.acYearOptions = response.data.map(el => ({
            ac_status_id: el.ac_status_id,
            value: el.ac_year_id,
            label:
              el.ac_year +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : ' ( Next ) ') +
              el.branch.branch_name_en
          }))
        })
    },
    getTerms() {
      this.fetchTerms()
        .then(response => {
          this.termOptions = response.data.map(el => ({
            value: el.ac_term_id,
            label: el.term_name
          }))
        })
        .finally(() => {
          this.acClassOptions = [] // always array, not null
          if (this.ac_term_id && this.ac_term_id.length) {
            this.fetchClass({
              ac_term_id: this.ac_term_id
            })
              .then(response => {
                this.acClassOptions = response.data.map(el => ({
                  value: el.class_id, // fixed key
                  label: el.class_name
                }))
              })
              .catch(error => {
                this.$toasted.error(error.message)
              })
          }
        })
    },
    onChangeTerms() {
      this.acClassOptions = []
      if (this.ac_term_id && this.ac_term_id.length) {
        this.fetchClass({
          ac_term_id: this.ac_term_id
        })
          .then(response => {
            this.acClassOptions = response.data.map(el => ({
              value: el.class_id, // fixed key
              label: el.class_name
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    onChangeAcYear() {
      this.termOptions = []
      this.$store
        .dispatch(
          'schedule/getTerm',
          Object.assign({ ac_year_id: this.ac_year_id })
        )
        .then(response => {
          this.termOptions = response.data.map(el => ({
            value: el.ac_term_id,
            label: el.term_name
          }))
        })
    },
    edit(record) {
      this.$store.commit('schedule/SET_FOUND_DATA', record)
      this.$router.push({
        name: 'schedule-edit',
        params: { id: record.sch_id }
      })
    },
    schedule(record) {
      this.$store.commit('schedule/SET_FOUND_DATA', record)
      this.$router.push({
        name: 'schedule-show',
        params: { id: record.sch_id }
      })
    },
    async copySchedule(record) {
      this.$store.commit('schedule/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'schedule-copy-schedule',
        params: {
          sch_id: record.sch_id, // <-- use sch_id here
          class_name: record.academic_class.class_name
        }
      })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function() {
      this.fetchData()
    }, 500),
    ac_year_id: debounce(function() {
      this.fetchData()
    }, 500),
    ac_term_id: debounce(function() {
      this.fetchData()
    }, 500),
    class_id: debounce(function() {
      this.fetchData()
    }, 500)
  }
}
</script>
